import Moment from 'moment'; 

export const columns = [
  {
    title: "Name",
    dataIndex: "name"
  },
  {
    title: "Email",
    dataIndex: "email"
  },
  {
    title: "Group",
    dataIndex: "group"
  },
  {
    title: "Created At",
    dataIndex: "createdAt",
    render: date => date ? Moment(date.toDate()).format("MM/DD/YYYY") : null
    
  }
];
